import React from 'react';
import { Cat, Check, Lock, Sparkles, Star } from 'lucide-react';
import { getSeenVerses } from '../services/bibleReaderService';
import { getAllEntries } from '../services/journalService';
import { getSavedGuides } from '../services/storageService';
import { getCachedDeliveryState } from '../services/verseDeliveryService';

const countItems = (loadItems) => {
    try {
        const items = loadItems();
        return Array.isArray(items) ? items.length : 0;
    } catch {
        return 0;
    }
};

const getBadges = () => [
    {
        name: 'First Delivery Valet',
        task: 'Schedule your first delivery rhythm',
        earned: countItems(() => getCachedDeliveryState().deliveries) > 0
    },
    {
        name: 'Still Waters',
        task: 'Open seven peaceful verses',
        earned: countItems(getSeenVerses) >= 7
    },
    {
        name: 'Quiet Scribe',
        task: 'Save your first journal reflection',
        earned: countItems(getAllEntries) > 0
    },
    {
        name: 'Path Keeper',
        task: 'Save your first personal prayer guide',
        earned: countItems(getSavedGuides) > 0
    }
];

export default function GrowthBadges() {
    const badges = getBadges();
    const earnedCount = badges.filter((badge) => badge.earned).length;

    return (
        <section className="vd-bombay-section">
            <header>
                <div>
                    <p>Playful growth inventory</p>
                    <h2>Black Bombay merits</h2>
                    <span>Outlandish rewards for real progress—never a measure of faith.</span>
                </div>
                <div className="vd-bombay-companion">
                    <Cat size={31} />
                    <span><strong>Bombay</strong><small>{earnedCount} of {badges.length} merits earned</small></span>
                </div>
            </header>

            <div className="vd-badge-inventory">
                {badges.map((badge, index) => (
                    <article className={badge.earned ? 'earned' : 'locked'} key={badge.name}>
                        <div>
                            <Cat size={34} />
                            <span>{index % 2 ? <Sparkles size={16} /> : <Star size={16} />}</span>
                        </div>
                        <small>{badge.earned ? 'Merit earned' : 'Not earned yet'}</small>
                        <h3>{badge.name}</h3>
                        <p>{badge.task}</p>
                        <footer>
                            {badge.earned
                                ? <><Check size={14} /> In your collection</>
                                : <><Lock size={13} /> Keep exploring</>}
                        </footer>
                    </article>
                ))}
            </div>
        </section>
    );
}
